import React, {Component} from 'react';

export class AlertsConfigurationSection extends Component {
    render() {
        return (
            <div className="section-body-item" style={{width:"100%"}}>
                <div className="box">
                    <div className="form-header" style={{marginBottom:"1.3em"}}>
                        <h3 className="form-title">{this.props.sectionName}</h3>
                    </div>
                    <div className="form-grid row-col-3" style={{marginBottom:"0em"}}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
